/** Custom event name to open the updates drawer (bell slide-out) or modal. Dispatched from Dashboard "See all" or when clicking an update. */
export const OPEN_UPDATES_DRAWER = "open-updates-drawer";

export interface OpenUpdatesDrawerDetail {
  /** When set, open the drawer and scroll to this update. */
  updateId?: number;
  /** When set, open the modal with this update (takes precedence over updateId). */
  update?: { id: number; title: string; description: string; created_at: string };
}
